import { createContext, useContext, useState, type ReactNode } from "react";

interface DetailPageChatContextValue {
  showChat: boolean;
  setShowChat: (show: boolean) => void;
  onChatClick?: () => void;
  setOnChatClick?: (handler: (() => void) | undefined) => void;
}

const DetailPageChatContext = createContext<DetailPageChatContextValue | undefined>(undefined);

export function DetailPageChatProvider({ children }: { children: ReactNode }) {
  const [showChat, setShowChat] = useState(false);
  const [onChatClick, setOnChatClick] = useState<(() => void) | undefined>(undefined);

  return (
    <DetailPageChatContext.Provider
      value={{
        showChat,
        setShowChat,
        onChatClick,
        setOnChatClick,
      }}
    >
      {children}
    </DetailPageChatContext.Provider>
  );
}

export function useDetailPageChat() {
  const context = useContext(DetailPageChatContext);
  if (!context) {
    return {
      showChat: false,
      setShowChat: () => {},
      onChatClick: undefined,
      setOnChatClick: () => {},
    };
  }
  return context;
}

